import React from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import bowser from 'bowser';
import useTerminology from '@sift/skipper/helpers/useTerminology';
import useEntityTypes from 'helpers/useEntityTypes';
import { BASE_FIELD_PAGE, BASE_FIELD_PAGE_COLLECTION } from './consts';
import { HOME_URL, ATTRIBUTES_URL, DYNAMIC_PAGES_URL } from 'components/Router/consts';

// Page
import PageTitle from 'components/Page/PageTitle';
import CustomToolbar from './components/CustomToolbar';
import CustomGridPanel from './components/CustomGridPanel';
import { attributeColumns, attributeRows } from './components/AttributeTableData';
import Typography from '@material-ui/core/Typography';
import { DataGrid } from '@material-ui/data-grid';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

function Attributes({ formats, globalConfig, classes, parentFields, profileAttributes }) {
  const isIE = bowser.name === 'Internet Explorer';
  const history = useHistory();
  const entityTypes = useEntityTypes();

  const terminology = useTerminology();

  const handleRowClick = params => {
    const field = _get(params, ['row', 'enabled']);
    if ([BASE_FIELD_PAGE, BASE_FIELD_PAGE_COLLECTION].includes(field.baseField)) {
      const entityType = Object.values(entityTypes).find(
        entityType => entityType._personClientFieldObjectKey === field.objectKey,
      );
      history.push({ pathname: `${HOME_URL}${DYNAMIC_PAGES_URL}/${entityType.id}` });
    } else if (_get(field, 'editable') || _get(field, 'deletable')) {
      history.push({
        pathname: `${HOME_URL}${ATTRIBUTES_URL}/${field.entityField}/edit/${field.objectKey}`,
      });
    } else {
      return null;
    }
  };

  return (
    <>
      <PageTitle subtitle="Manage pieces of information related to people in Sift to be added to your profiles and/or synced from a data source." />
      <div className={classes.wrapper}>
        {isIE && (
          <Typography variant="h4">
            This page is not supported in Internet Explorer. Please use another browser.
          </Typography>
        )}
        <DataGrid
          className={classes.row}
          rows={attributeRows(parentFields)}
          columns={attributeColumns(globalConfig, classes, profileAttributes, terminology)}
          disableColumnMenu
          disableColumnSelector
          disableColumnReorder
          disableSelectionOnClick
          onRowClick={handleRowClick}
          sortModel={[{ field: 'displayName', sort: 'asc' }]}
          components={{
            Toolbar: CustomToolbar,
            Panel: CustomGridPanel,
          }}
          componentsProps={{
            toolbar: {
              formats,
              buttonText: 'New Attribute',
            },
          }}
        />
      </div>
    </>
  );
}

Attributes.propTypes = {
  subdomain: PropTypes.string.isRequired,
  globalConfig: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  parentFields: PropTypes.array.isRequired,
  profileAttributes: PropTypes.array.isRequired,
};

const styles = theme => {
  return {
    pageContent: {
      paddingRight: 0,
      paddingBottom: 0,
    },
    wrapper: {
      height: '100vh',
      width: '100%',
    },
    row: {
      cursor: 'pointer',
      border: 'none',
    },
    circleIcon: {
      width: theme.spacing(),
      height: theme.spacing(),
      marginRight: theme.spacing(0.75),
    },
    grayIcon: {
      color: theme.colors.gray1,
    },
    greenCircleIcon: {
      color: theme.palette.success.main,
    },
    disabled: {
      opacity: theme.palette.opacity.thirtyEightPercent,
    },
    cell: {
      '&:focus': {
        outline: 'none !important',
      },
    },
    noClick: {
      cursor: 'default',
    },
  };
};

export default withStyles(styles)(Attributes);
